import React from "react";
import "./BathroomCleaningService.css";

const BathroomCleaningService = () => {
  return (
    <div className="bathroomcleaning-cleaning-container">
      <h1>Fresh and Germ-Free Bathrooms</h1>
      <p>
        We'll scrub and disinfect toilets, showers, tubs, and vanities. We'll
        also clean mirrors and polish fixtures.
      </p>
      <h2>What’s Included:</h2>
      <ul>
        <li>Scrub and disinfect toilets, showers, and tubs</li>
        <li>Sanitize vanities and counters</li>
        <li>Clean mirrors</li>
        <li>Polish fixtures</li>
      </ul>
    </div>
  );
};

export default BathroomCleaningService;
